import React from 'react';
import PrimaryButton from '../../../../../../Elements/ids/Buttons/PrimaryButton';
import SecondaryButton from '../../../../../../Elements/ids/Buttons/SecondaryButton';
import { formatMessage } from '../../../../../../Localization/formatMessage';
import Messages from '../../../../../../Localization/Messages';

const HistoricalAgentInfoButtons = ({ closeView, onClickEvent, error }) => {
  return (
    <>
      {error ? (
        <SecondaryButton text={formatMessage(Messages.common_close)} onClickEvent={closeView} />
      ) : (
        <PrimaryButton text={formatMessage(Messages.historicalAgents_reactivateButton)} onClickEvent={onClickEvent} />
      )}
    </>
  );
};

export default HistoricalAgentInfoButtons;
